/**
 * Die Kopfzeile einer Board-Gruppe - der `<tr class="order-list-group-row">`-Block aus
 * `renderBoard` (index.html:7026-7036).
 *
 * ================= Woertlich uebernommene Eigenheiten =================
 *
 * 1. Der Pfeil ist ein PAAR: BEIDE Symbole (`chevrons-right` mit `collapse-closed`,
 *    `chevrons-down` mit `collapse-open`) stehen immer im Baum; welches sichtbar ist, entscheidet
 *    CSS ueber `.collapse-pair`. Das ist die „bewusste Verbesserung 2" der Spec (kein Flackern beim
 *    Neuzeichnen) und deshalb NICHT auf ein bedingt gerendertes Symbol zu vereinfachen - die
 *    Baseline haelt beide fest (`board-standard`, Knoten 437 und 440).
 * 2. `colSpan` ist die Zahl der SICHTBAREN Spalten, nicht die der konfigurierten.
 * 3. Die Summe steht auch dann da, wenn sie leer ist: `fmtMixedTotals` liefert bei lauter
 *    Nullbetraegen die leere Zeichenkette, der `<span class="order-list-group-sum">` bleibt aber.
 * 4. `aria-expanded` traegt den UMGEKEHRTEN Wert von `collapsed` - und die Klasse `collapsed` sitzt
 *    auf dem `<tr>`, nicht auf dem Knopf.
 */
import { fmtMixedTotals } from "../../lib/money.ts";
import type { BoardGroup } from "../../config/board.ts";
import type { Order, Supplier } from "../../lib/types.ts";
import { Ikone } from "../Ikone.tsx";
import { NUM } from "../../lib/format.ts";

export interface GruppenzeileProps {
  gruppe: BoardGroup;
  bestellungen: readonly Order[];
  lieferanten: readonly Supplier[] | null | undefined;
  eingeklappt: boolean;
  spaltenzahl: number;
  /** `toggleBoardSection(group.id)`, index.html:7029. */
  onUmschalten: (gruppenId: string) => void;
}

export function Gruppenzeile({
  gruppe,
  bestellungen,
  lieferanten,
  eingeklappt,
  spaltenzahl,
  onUmschalten,
}: GruppenzeileProps) {
  return (
    <tr className={`order-list-group-row ${eingeklappt ? "collapsed" : ""}`}>
      <td colSpan={spaltenzahl}>
        <button
          className="order-list-group-button"
          type="button"
          aria-expanded={eingeklappt ? "false" : "true"}
          onClick={() => onUmschalten(gruppe.id)}
        >
          <span className="order-list-group-arrow collapse-pair" aria-hidden="true">
            <Ikone name="chevrons-right" className="collapse-closed" />
            <Ikone name="chevrons-down" className="collapse-open" />
          </span>
          <span className="order-list-group-name">{gruppe.label}</span>
          <span className="order-list-group-count">{NUM.format(bestellungen.length)}</span>
          <span className="order-list-group-sum">{fmtMixedTotals(bestellungen, lieferanten)}</span>
        </button>
      </td>
    </tr>
  );
}
